import SharedPropsService from "../../../../SharedPropsService";
import AsyncStorage from "@react-native-async-storage/async-storage";
export var PollarStatus;
(function (PollarStatus) {
    PollarStatus["SUCCESS"] = "SUCCESS";
    PollarStatus["FAILED"] = "FAILED";
    PollarStatus["IN_PROGRESS"] = "IN_PROGRESS";
})(PollarStatus || (PollarStatus = {}));
export const getApplicationId = async () => {
    const user = await SharedPropsService.getUser();
    return await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : user.linkedApplications[0].applicationId;
};
